import BankingCadsRules from 'components/Banking/Cards';
import Button from 'components/Form/Button';
import Input from 'components/Form/Input';
import Toggle from 'components/Form/Toggle';
import { CoreContext } from 'context/CoreContext';
import { useContext, useState } from 'react';
import { FormSpacer, Icon, Title } from 'ui/styled';
import {
  ButtonContent,
  ContainerOutlined,
  HeaderActions,
  Link,
  TableHeaderSubTitle,
  TableHeaderTitleContainer,
  TableWrapperButtonContainer,
  TableWrapperContainer,
  TableWrapperHeader,
} from './styled';

export default function TableWrapper({
  children,
  title,
  search,
  subTitle,
  buttons,
  noTop,
  background,
  link,
  onLink,
  toggle,
  nospace,
  distribuidor,
}) {
  const { searchExpression, setSearchExpression } = useContext(CoreContext);
  const [checked, setChecked] = useState(true);
  const handleSearchChange = (event) => setSearchExpression(event.target.value);

  return (
    <TableWrapperContainer background={background}>
      <TableWrapperHeader>
        <TableHeaderTitleContainer>
          {!title ? null : (
            <Title small nomargin>
              {!toggle ? null : (
                <Toggle label={title} checked={checked} onChange={setChecked} />
              )}
              {toggle ? null : title}
              {!subTitle ? null : (
                <TableHeaderSubTitle>
                  {subTitle} {link && <Link onClick={onLink}>{link}</Link>}
                </TableHeaderSubTitle>
              )}
            </Title>
          )}
          <HeaderActions>
            {distribuidor && <BankingCadsRules distribuidor={distribuidor} />}
            {!search ? null : (
              <ContainerOutlined white noTop={noTop}>
                <Input
                  placeholder="Pesquisar"
                  search
                  holder
                  small
                  transparent
                  type="text"
                  endIcon={<Icon icon="search" />}
                  value={searchExpression}
                  onChange={handleSearchChange}
                />
              </ContainerOutlined>
            )}
          </HeaderActions>
        </TableHeaderTitleContainer>
        <TableWrapperButtonContainer>
          {buttons?.map((m) => (
            <ButtonContent>
              <Button
                color={m?.color}
                startIcon={m?.icon && <Icon icon={m?.icon} nomargin />}
                small
                nospace
                onClick={m?.action}
                border={m?.border}
                loading={m?.loading}
              >
                {m?.centerIcon ? null : m?.label}
                {m?.centerIcon && <Icon icon={m?.centerIcon} nomargin />}
              </Button>
            </ButtonContent>
          ))}
        </TableWrapperButtonContainer>
      </TableWrapperHeader>
      {nospace ? null : <FormSpacer />}
      {children}
    </TableWrapperContainer>
  );
}
